<template lang="pug">
  .lei-input(:class="rootClass")
    lei-popover(:text="tip", :placement="tipPlacement")
      label.label(:for="cbId") {{label}}
    .input-range
      input.input.input-min(
      :id="cbId", :value="min", type="number",
      @input="emitEvent($event, 'input-min')",
      @change="emitEvent($event, 'change-min')",
      @keyup.enter="keyEnter"
      v-bind="inputAttrs", :max="max")
      | ‒
      input.input.input-max(
      :id="cbId", :value="max", type="number",
      @keyup.enter="keyEnter"
      @input="emitEvent($event, 'input-max')",
      @change="emitEvent($event, 'change-max')",
      v-bind="inputAttrs", :min="min")
</template>

<script>
import cdId from '../../../mixins/cd-id'
import LeiPopover from '../LeiPopover'

export default {
  components: { LeiPopover, },
  mixins: [ cdId, ],
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    min: {
      type: [ Number, String, ],
      default: 0,
    },
    max: {
      type: [ Number, String, ],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    inputAttrs: {
      type: Object,
      default: () => ({}),
    },
    tip: {
      type: [ String, Object, ],
      default: () => ({
        small: '',
        full: '',
      }),
    },
    tipPlacement: {
      type: [ String, ],
      default: 'right',
    },
  },
  methods: {
    emitEvent ({ target: { value, }, }, event) {
      this.$emit(event, value)
    },
    keyEnter (e) {
      this.$emit('enter', e.target.value)
    },
  },
}
</script>

<style lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .lei-input
    .input-range
      display flex
      justify-content space-between
      align-items center
      .input
        text-align center
        width calc(50% - 10px)
</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/LeiInputRange.vue